import { render, staticRenderFns } from "./object-picker-br.vue?vue&type=template&id=2b5e246b&scoped=true"
import script from "./object-picker-br.vue?vue&type=script&lang=js"
export * from "./object-picker-br.vue?vue&type=script&lang=js"
import style0 from "./object-picker-br.vue?vue&type=style&index=0&id=2b5e246b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5e246b",
  null
  
)

export default component.exports